// 前端 API 配置。
// 注意：这里不放任何第三方密钥——浏览器里的代码任何人都能读到。
// OpenAI / Azure 的调用统一走同源的 Cloudflare Pages Functions（见 functions/api/），密钥只存在服务端。

export const API_CONFIG = {
  api: {
    chat: '/api/chat',
    tts: '/api/tts',
    health: '/api/health'
  },

  // 调试配置：生产构建默认关闭，需要时用 VUE_APP_DEBUG_LOGS=true 打开
  debug: {
    enableLogs: process.env.NODE_ENV !== 'production' || process.env.VUE_APP_DEBUG_LOGS === 'true',
    enhancedSSML: process.env.VUE_APP_ENHANCED_SSML === 'true'
  },

  // 语音配置（服务端 functions/api/tts.js 有同样的白名单）
  voices: {
    cantonese: {
      female: 'zh-HK-HiuMaanNeural',
      male: 'zh-HK-WanLungNeural'
    },
    english: {
      female: 'en-US-JennyMultilingualNeural',
      male: 'en-US-BrandonNeural'
    },
    mandarin: {
      female: 'zh-CN-XiaoxiaoNeural',
      male: 'zh-CN-YunjianNeural'
    }
  }
}

// 前端没有密钥可验，保留该函数只为兼容旧调用；真正的配置状态见 checkServerHealth()
export function validateApiConfig() {
  return true
}

// 询问服务端 Secrets 是否已配置（不会调用 OpenAI / Azure，不消耗额度）
export async function checkServerHealth() {
  const response = await fetch(API_CONFIG.api.health)
  if (!response.ok) throw new Error(`HTTP ${response.status}`)
  return response.json()
}

export function getConfigSummary() {
  return {
    chatEndpoint: API_CONFIG.api.chat,
    ttsEndpoint: API_CONFIG.api.tts,
    debugLogs: API_CONFIG.debug.enableLogs,
    voices: Object.keys(API_CONFIG.voices)
  }
}
